var config = {
	
	
	
	
}

export default {
	config
}


